import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "k-input__remove-icon-box row items-center q-anchor--skip q-anchor--close-icon transition"
}

import { ref, watch } from 'vue'
import type { QInput } from 'quasar'

interface IProps {
  modelValue: string | number
  rootClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  externalLabelClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
  icon?: string | null
  rightIcon?: string | null
  hasClearIcon?: boolean
  isPassword?: boolean
  externalLabel?: string
  externalLabelDescription?: string
  externalLabelCalloutTitle?: string
  externalLabelCalloutDescription?: string
  small?: boolean
  disable?: boolean
  resetValidationOnInput?: boolean
  textareaMinHeight?: string
}

interface IEmits {
  (event: 'update:modelValue', data: string | number): void
  (event: 'clear', data: void): void
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KInput', inheritAttrs: false },
  __name: 'KInput',
  props: {
    modelValue: {},
    rootClass: { default: '' },
    externalLabelClass: { default: '' },
    icon: { default: null },
    rightIcon: { default: null },
    hasClearIcon: { type: Boolean, default: true },
    isPassword: { type: Boolean, default: false },
    externalLabel: { default: '' },
    externalLabelDescription: { default: '' },
    externalLabelCalloutTitle: { default: '' },
    externalLabelCalloutDescription: { default: '' },
    small: { type: Boolean, default: false },
    disable: { type: Boolean, default: false },
    resetValidationOnInput: { type: Boolean, default: true },
    textareaMinHeight: { default: '192px' }
  },
  emits: ["update:modelValue", "clear"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

_useCssVars(_ctx => ({
  "f01413b0": (_ctx.textareaMinHeight)
}))



const props = __props

const emit = __emit

const inputValue = ref(props.modelValue)
const passwordShowable = ref(false)
const inputRef = ref<QInput | null>(null)

__expose({ inputRef })

watch(
  () => props.modelValue,
  (newValue) => {
    inputValue.value = newValue
  },
)
watch(inputValue, (newValue) => {
  if (props.resetValidationOnInput) inputRef.value?.resetValidation()
  emit('update:modelValue', newValue)
})

function onClear() {
  inputValue.value = ''
  emit('clear')
}

return (_ctx: any,_cache: any) => {
  const _component_KExternalLabel = _resolveComponent("KExternalLabel")!
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([__props.rootClass])
  }, [
    _renderSlot(_ctx.$slots, "label", {}, () => [
      (__props.externalLabel)
        ? (_openBlock(), _createBlock(_component_KExternalLabel, {
            key: 0,
            class: _normalizeClass([__props.externalLabelClass, __props.disable ? 'text-cool-gray-60' : '']),
            "description-color": __props.disable ? 'cool-gray-60' : '',
            description: __props.externalLabelDescription,
            for: _ctx.$attrs['for'],
            label: __props.externalLabel,
            required: _ctx.$attrs['is-required'],
            "callout-title": __props.externalLabelCalloutTitle,
            "callout-description": __props.externalLabelCalloutDescription
          }, {
            before: _withCtx(() => [
              _renderSlot(_ctx.$slots, "before-external-label")
            ]),
            _: 3
          }, 8, ["class", "description-color", "description", "for", "label", "required", "callout-title", "callout-description"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_q_input, _mergeProps({
      ref_key: "inputRef",
      ref: inputRef,
      modelValue: inputValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputValue).value = $event)),
      class: ["base-input q-pb-none", { 'small-input': __props.small }],
      placeholder: _ctx.$attrs['placeholder'],
      type: __props.isPassword && !passwordShowable.value ? 'password' : 'text',
      disable: __props.disable,
      dense: "",
      "no-error-icon": "",
      "bottom-slots": "",
      borderless: "",
      autogrow: _ctx.$attrs['type'] === 'textarea'
    }, _ctx.$attrs), _createSlots({ _: 2 }, [
      (__props.icon)
        ? {
            name: "prepend",
            fn: _withCtx(() => [
              _createVNode(_component_KIcon, {
                name: __props.icon,
                color: "cool-gray-70"
              }, null, 8, ["name"])
            ]),
            key: "0"
          }
        : undefined,
      (__props.rightIcon || __props.isPassword || (__props.hasClearIcon && inputValue.value))
        ? {
            name: "append",
            fn: _withCtx(() => [
              (__props.rightIcon)
                ? (_openBlock(), _createBlock(_component_KIcon, {
                    key: 0,
                    name: __props.rightIcon,
                    color: "cool-gray-70",
                    size: "24px"
                  }, null, 8, ["name"]))
                : (__props.isPassword)
                  ? (_openBlock(), _createBlock(_component_KIcon, {
                      key: 1,
                      name: !passwordShowable.value ? 'eye-with-line' : 'eye',
                      class: "cursor-pointer",
                      color: "cool-gray-70",
                      size: "24px",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (passwordShowable.value = !passwordShowable.value))
                    }, null, 8, ["name"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_component_KIcon, {
                        name: "remove",
                        size: "20px",
                        color: "inherit",
                        class: "q-anchor--skip cursor-pointer",
                        onClick: _withModifiers(onClear, ["stop","prevent"])
                      })
                    ]))
            ]),
            key: "1"
          }
        : undefined,
      _renderList(Object.keys(_ctx.$slots), (slot) => {
        return {
          name: slot,
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, slot)
          ])
        }
      })
    ]), 1040, ["modelValue", "class", "placeholder", "type", "disable", "autogrow"])
  ], 2))
}
}

})